import React, {ReactNode, useState} from 'react';
import Page from "components/Page";
import {useAuth} from "../../../context/AuthContext";
import NotAuthorised from "../../NotAuthorised";
import {Steps} from "../../../components/Steps";
import {TwoFactorAuthChooseApp} from "../Forms";
import {TwoFactorAuthScanQRCode} from "../Steps/TwoFactorAuthScanQrCode";
import {TwoFactorAuthConfirmCode} from "../Steps/TwoFactorAuthConfirmCode";
import Button from "../../../components/Button";
import {useNavigate} from "react-router-dom";
import {TwoFactorAuthRecoveryCodes} from "../Steps/TwoFactorAuthRecoveryCodes";

// Component ----

function TwoFactorAuthSetup() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);

  function stepForward() {
    setStep(current => current + 1);
  }

  function stepBack() {
    setStep(current => current - 1);
  }

  const stepOptions: Record<number, { element: ReactNode }> = {
    1: { element: <TwoFactorAuthChooseApp onContinue={stepForward}/>},
    2: { element: <TwoFactorAuthScanQRCode onBack={stepBack} onContinue={stepForward} />},
    3: { element: <TwoFactorAuthConfirmCode onBack={stepBack} onContinue={stepForward} />},
    4: { element: <TwoFactorAuthRecoveryCodes />},
  }

  // Prevent unauthorised mutating
  if (auth.cannot('users:write:own')) {
    return <NotAuthorised/>
  }

  return (
    <Page
      title='Two-factor authentication (2FA)'
      breadcrumbs={{'User Settings': '/user-settings'}}
    >
      <div className='flex flex-col gap-4 max-w-4xl'>
        {(auth.user?.two_factor_confirmed && step === 1) ? (
          <div className="flex flex-col items-start gap-8 shadow bg-white rounded-md p-4 sm:p-6">
            <p className='text-sm text-gray-900'>2FA has already been enabled.</p>

            <Button
              type='button'
              color={Button.colors.PRIMARY}
              onClick={() => navigate('/user-settings', {replace: true})}
            >
              Back to User Settings
            </Button>
          </div>
        ) : (
          <>
            <div className="shadow px-4 sm:px-6 bg-white rounded-md">
              <Steps activeStep={step} numberOfSteps={Object.keys(stepOptions).length} />
            </div>

            {stepOptions[step]?.element}
          </>
        )}
      </div>
    </Page>
  );
}

export default TwoFactorAuthSetup;